export const DeleteBanner = ["Expired Promotion or Event", "Incorrect Information", "Inappropriate Content", "Rebranding or Campaign Change", "Design or Layout Issues"];

export const rolesOptions = [
  { name: "dashboard-management", label: "Dashboard Management" },
  { name: "student-manager", label: "Student Management" },
  { name: "teacher-manager", label: "Teacher Management" },
  { name: "event-manager", label: "Event Type Management" },
  { name: "service-manager", label: "Service Management" },
  { name: "category-management", label: "Category Management" },
  { name: "sub-category-management", label: "Sub Category Management" },
  { name: "keyword-emotion-management", label: "Keyword / Emotions Management" },
  { name: "faq-management", label: "FAQ Management" },
  { name: "quotation-request", label: "Quotation Request Management" },
  { name: "cms-manager", label: "CMS Management" },
  // { name: "delivery-manager", label: "Delivery History Management" },
  // { name: "rating-manager", label: "Rating and Reviews Management" },
  // { name: "report-manager", label: "Reports Management" },
  // { name: "banner-manager", label: "Banner Management" },
  // { name: "finance-manager", label: "Financial Management" },
  // { name: "collector-manager", label: "Collection Management" },
  // { name: "service-location-manager", label: "Service Location  Management" },
  // { name: "delivery-charge-manager", label: "Delivery charge  Management" },
  { name: "Notifications", label: "Notifications Management" },
  { name: "email-template-manager", label: "Email Template Management" },
  { name: "email-log-management", label: "Email Logs Management" },
];

export const colorOptions = [
  { value: "red", name: "Red" },
  { value: "green", name: "Green" },
  { value: "blue", name: "Blue" },
  { value: "yellow", name: "Yellow" },
  { value: "orange", name: "Orange" },
  { value: "purple", name: "Purple" },
  { value: "pink", name: "Pink" },
  { value: "brown", name: "Brown" },
  { value: "black", name: "Black" },
  { value: "white", name: "White" },
  { value: "gray", name: "Gray" },
  { value: "cyan", name: "Cyan" },
  { value: "magenta", name: "Magenta" },
  { value: "lime", name: "Lime" },
  { value: "teal", name: "Teal" },
  { value: "indigo", name: "Indigo" },
  { value: "violet", name: "Violet" },
  { value: "maroon", name: "Maroon" },
  { value: "navy", name: "Navy" },
  { value: "gold", name: "Gold" },
];

export const webPageHeadingOptions = [
  { _id: "user_safety_support", name: "user_safety_support" },
  { _id: "user_safety_toolkit", name: "user_safety_toolkit" },
  { _id: "user_privacy_tools", name: "user_privacy_tools" },
  { _id: "user_account_security", name: "user_account_security" },
  { _id: "leadership", name: "leadership" },
  { _id: "work_at", name: "work_at" },
  { _id: "privacy_policy", name: "privacy_policy" },
  { _id: "terms_and_conditions", name: "terms_and_conditions" },
  { _id: "about_us", name: "about_us" },
  { _id: "contact_us", name: "contact_us" },
  { _id: "faq", name: "faq" },
  { _id: "sitemap", name: "sitemap" },
];
